import React from 'react';
import PropTypes from 'prop-types';

/**
 * CustomHeaderMenuRowRenderer Component in Table
 * @function CustomHeaderMenuRowRenderer
 * @param {string} className  -- className of input
 * @param {Object} columns -- array of objects representing column data
 * @param {Object} style -- wrapper div style
 * @return {ReactElement}
 */
const CustomHeaderMenuRowRenderer = ({ className, columns, style }) => {
  const newStyle = { ...style };
  return (
    <div className={className} role="row" style={newStyle}>
      {columns}
      <div style={{
        minWidth: '32px',
        position: 'relative',
        flex: '1 1 100px',
        height: '100%',
        width: '32px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        marginRight: '10px',
      }} />
    </div>
  );
};

CustomHeaderMenuRowRenderer.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.objectOf(
      PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.func,
      ]),
    )
  ).isRequired,
  className: PropTypes.string,
  style: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  ),
};

export default CustomHeaderMenuRowRenderer;
